export type NavigationTab = 
  | 'ChildNav'
  | 'Milestones' 
  | 'Concerns'
  | 'Well-Visit'
  | 'Activities'
  | 'Guidance'
  | 'ResourceList'
  | 'Actions'
  | 'ManageProfiles'
  | 'Connections'
  | 'ReferAFriend'
  | 'Account'
  | 'Settings'
  | 'More';

export interface TabConfig {
  id: NavigationTab;
  label: string;
  icon: string;
  description: string;
}

export interface NavigationProps {
  activeTab: NavigationTab;
  onTabChange: (tab: NavigationTab) => void;
}

export interface ChildNavProps {
  name?: string;
  color?: string;
  initialTab?: NavigationTab;
  storage?: any; // StorageInterface from platform-specific implementation
  apiService?: any; // ApiService from platform-specific implementation
  iapService?: any; // IAPService from mobile — undefined on web
}

// Tab configuration for the bottom navigation
export const TAB_CONFIGS: Record<NavigationTab, TabConfig> = {
  ChildNav: {
    id: 'ChildNav',
    label: 'Home',
    icon: '🏠',
    description: 'Main dashboard and navigation hub'
  },
  Milestones: {
    id: 'Milestones',
    label: 'Milestones',
    icon: '🌟',
    description: 'Track developmental milestones'
  },
  Concerns: {
    id: 'Concerns',
    label: 'Concerns',
    icon: '⚠️',
    description: 'Address concerns and issues'
  },
  'Well-Visit': {
    id: 'Well-Visit',
    label: 'Well-Check',
    icon: '🏥',
    description: 'Schedule well-checks and manage snapshots'
  },
  Activities: {
    id: 'Activities',
    label: 'Activities',
    icon: '🎯',
    description: 'Fun developmental activities'
  },
  Guidance: {
    id: 'Guidance',
    label: 'Guidance',
    icon: '📚',
    description: 'Parenting guidance and tips'
  },
  ResourceList: {
    id: 'ResourceList',
    label: 'Resource List',
    icon: '📋',
    description: 'National, state and local services, hotlines and contacts'
  },
  Actions: {
    id: 'Actions',
    label: 'Actions',
    icon: '✅',
    description: 'Action items and plan'
  },
  ManageProfiles: {
    id: 'ManageProfiles',
    label: 'Manage Profiles',
    icon: '🧒',
    description: 'View, edit, and manage child profiles'
  },
  Connections: {
    id: 'Connections',
    label: 'Connections',
    icon: '🔗',
    description: 'Manage provider connections'
  },
  Account: {
    id: 'Account',
    label: 'Account',
    icon: '👨‍👩‍👧‍👦',
    description: 'My account, family access and refer a friend'
  },
  Settings: {
    id: 'Settings',
    label: 'Settings',
    icon: '⚙️',
    description: 'App settings and preferences'
  },
  More: {
    id: 'More',
    label: 'More',
    icon: '☰',
    description: 'Additional navigation options'
  },
  ReferAFriend: {
    id: 'ReferAFriend',
    label: 'Refer a Friend',
    icon: '👫',
    description: 'Refer a friend to ChildNav'
  }
};